import script from "./Group.vue?vue&type=script&lang=ts&setup=true"
export * from "./Group.vue?vue&type=script&lang=ts&setup=true"

import "./Group.vue?vue&type=style&index=0&id=06d073c0&lang=scss&scoped=true"
import "./Group.vue?vue&type=style&index=1&id=06d073c0&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d073c0"]])

export default __exports__